import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins'
import "./directives/can_bindings";
import vuetify from './plugins/vuetify';
import permissionGuard from './router/guards/permissionsGuard'


permissionGuard(router, store)

Vue.config.productionTip = false

//Vue.use(vuetify);
//Vue.use(require('vue-chartist'))

let pathName = location.pathname.split("/")[1];
if (pathName !== "projetos-simplifica") {
  pathName = "";
}
if (keycloak) {
  keycloak.init({
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: location.origin + (pathName ? "/" : '') + pathName + "/check-sso.html",
  }).then(async function(autenticado) {
    if (autenticado) {
      await store.dispatch("getInfo");
    } else {
      await store.dispatch("logout");
    }
    new Vue({router, store, vuetify, render: (h) => h(App),}).
      $mount("#app");
  });
} else {
  new Vue({router, store, vuetify, render: (h) => h(App),}).
    $mount("#app");
}
